﻿(function (angular) {
  "use strict";

  angular.module("Toyota.Directives").directive("tyTruncateText", [
    "$timeout",
    "$parse",
    function ($timeout, $parse) {
      var controller = function () {
        var ctl = this;

        function init() {
          ctl.collapsed = true;
          ctl.collapsible = false;
          ctl.repaint();
        }

        ctl.repaint = function () {
          var finalText = ctl.collapsed ? truncate(ctl.fullDescription, ctl.collapseLength) : ctl.fullDescription;
          $timeout(function () {
            ctl.finalText = finalText;
          });
        };

        var ELLIPSIS_LENGTH = 3;

        function truncate(text, length) {
          var textLength = text.length;
          var result = text;
          ctl.collapsible = false;

          if (textLength > length) {
            ctl.collapsible = true;
            var index = length - ELLIPSIS_LENGTH;
            result = result.substring(0, index);
            var indexChar = result.charAt(index + 1);

            if (indexChar === " ") {
              result += "...";
            } else if (indexChar === ".") {
              result += "..";
            } else {
              var lastIndex = result.lastIndexOf(" ");
              result = result.substring(0, lastIndex);

              var endsWithPeriodRegex = /\.$/;

              if (result.match(endsWithPeriodRegex)) {
                result += "..";
              } else {
                result += "...";
              }
            }
          }

          return result;
        }

        ctl.expandText = function expandText() {
          ctl.collapsed = false;
          ctl.repaint();
        };

        ctl.collapseText = function collapseText() {
          ctl.collapsed = true;
          ctl.repaint();
        };

        ctl.$onInit = init;
      };

      var link = function ($scope, $element, $attrs, $ctrl) {
        $ctrl.onDidClickCollapseLink = function () {
          $parse($attrs.onDidClickCollapseLink)($scope);
        };

        $ctrl.onDidClickExpandLink = function () {
          $parse($attrs.onDidClickExpandLink)($scope);
        };
      };

      return {
        restrict: "E",
        bindToController: {
          collapseLength: "@collapseLength",
          collapseLinkText: "@collapseLinkText",
          expandLinkText: "@expandLinkText",
          fullDescription: "@fullDescription",
          theme: "@theme",
        },
        scope: false,
        controller: controller,
        // prettier-ignore
        template:
          "<div class=\"ty-truncate-text {{tyTruncateText.theme ? 'ty-truncate-text--' + tyTruncateText.theme : ''}}\">" +
            '<div class="ty-truncate-text__content" ng-bind-html="tyTruncateText.finalText"></div>' +
            '<div class="ty-truncate-text__button-container">' +
              '<button class="ty-truncate-text__button ty-truncate-text__button--expand" ' +
                      'ng-click="tyTruncateText.expandText(); tyTruncateText.onDidClickExpandLink();" ' +
                      'ng-show="tyTruncateText.collapsible && tyTruncateText.collapsed">' +
                "{{tyTruncateText.expandLinkText}}" +
              "</button>" +
              '<button class="ty-truncate-text__button ty-truncate-text__button--collapse" ' +
                      'ng-click="tyTruncateText.collapseText(); tyTruncateText.onDidClickCollapseLink();" ' +
                      'ng-show="tyTruncateText.collapsible && !tyTruncateText.collapsed">' +
                "{{tyTruncateText.collapseLinkText}}" +
              "</button>" +
            "</div>" +
          "</div>",
        controllerAs: "tyTruncateText",
        replace: true,
        link: link,
      };
    },
  ]);
})(window.angular);
